/* Delegate so Shopify's cart section replacements retain disclosure motion. */
(() => {
  if (window.kindraCartDisclosureMotion) return;
  window.kindraCartDisclosureMotion = true;
  const motions = new WeakMap();
  document.addEventListener('click', event => {
    const summary = event.target.closest?.('.kindra-cart-line__details > summary');
    if (!summary || !window.matchMedia('(max-width:999px)').matches ||
        window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    const details = summary.parentElement;
    if (!details.animate) return;
    event.preventDefault();
    const previous = motions.get(details);
    const opening = previous ? !previous.opening : !details.open;
    const start = details.getBoundingClientRect().height;
    previous?.animation.cancel();
    details.open = true;
    const end = opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
    details.style.overflow = 'hidden';
    const animation = details.animate(
      { height: [start + 'px', end + 'px'] },
      { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' }
    );
    motions.set(details, { animation, opening });
    animation.onfinish = () => {
      if (motions.get(details)?.animation !== animation) return;
      details.open = opening;
      details.style.removeProperty('overflow');
      motions.delete(details);
    };
  });
})();
